export default __webpack_public_path__ + "static/media/resetPassRedIcon.abf2abe9.svg";